<template>
  <v-app>
    <!-- Header -->
    <!-- <base-header v-show="!reseller_page" :key="componentKey">
      <v-app-bar-nav-icon
        slot="nav-drawer"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </base-header>

    <span>
      <base-navigation-drawer
        v-show="drawer && !reseller_page"
        v-model="drawer"
        :key="componentKey"
      ></base-navigation-drawer>
    </span> -->

    <base-navigation-bar></base-navigation-bar>

    <!-- Content -->
    <v-main>
      <router-view></router-view>
    </v-main>

    <!-- Footer -->
    <base-footer v-show="!reseller_page"></base-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    drawer: false,
    reseller_drawer: false,
    // componentKey: 0
  }),

  computed: {
    reseller_page() {
      return this.$route.name == 'ResellerHome' || this.$route.name == 'ResellerKeyAssignment'
          || this.$route.name == 'ResellerCheckout'
    }
  },

  // watch: {
  //   "$vuetify.breakpoint.name": {
  //     handler: function(value, oldValue) {
  //       console.log({ value, oldValue })
  //       this.componentKey++;
  //     },
  //     immediate: true
  //   },
  //   "$router": {
  //     handler: function(value, oldValue) {
  //       console.log({ value, oldValue }, "router");
  //     },
  //     immediate: true
  //   }
  // },

  mounted() {
    console.log('[Tuesday, February 23, 2021 2AM]')
  },

  methods: {
    //
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";
@import '~vuetify/src/styles/settings/_variables';

html, body {
  scroll-behavior: smooth;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  html, body {
    overflow-x: hidden;
  }
}
</style>